<style scoped>
.sub-th {
  text-align: center !important;
  border: thin solid rgba(0, 0, 0, 0.2) !important;
  color: black !important;
  font-size: 10px !important;
  white-space: nowrap;
}

.th-ellipsis {
  max-width: 260px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  text-align: left !important;
  border: thin solid rgba(0, 0, 0, 0.2) !important;
  color: black !important;
}
.n-ellipsis {
  max-width: 100px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  text-align: center !important;
  border: thin solid rgba(0, 0, 0, 0.2) !important;
  color: black !important;
}
.th-ellipsis:hover {
  text-overflow: clip;
  white-space: normal;
  word-break: break-all;
  width: 100%;
}
.v-data-table-header-mobile {
  display: none !important;
}

.sticky-col {
  position: -webkit-sticky;
  position: sticky;
  background-color: white;
}

.first-col {
  width: 75px;
  left: 0px;
  text-align: center !important;
  border: thin solid rgba(0, 0, 0, 0.2) !important;
  color: black !important;
}
</style>

<template>
  <div>
    <div
      class="mt-n8 mb-3 ml-6"
      style="font-size: 1.35rem"
      color="blue"
    >
      รายชื่อผู้ลงทะเบียน
      <v-divider class="mt-1"></v-divider>
    </div>
    <div class="mx-5">
      <v-row>
        <v-col
          cols="12"
          sm="12"
          lg="2"
        >
          <v-card elevation="3">
            <v-card-title>
              <v-row>
                <v-col cols="12">
                  <v-autocomplete
                    :items="ss_data"
                    solo
                    v-model="ss"
                    dense
                    item-text="NAME"
                    item-value="ID"
                  ></v-autocomplete>
                </v-col>
                <v-col cols="12">
                  <!-- <v-autocomplete
                    :items="p_data"
                    v-model="p_type"
                    dense
                    label="ประเภทบุคคล"
                    item-text="TEXT"
                    item-value="VALUE"
                    solo
                  ></v-autocomplete> -->
                  <v-text-field
                    dense
                    solo
                    v-model="fullname"
                    label="ชื่อ - นามสกุล"
                    class="mt-n10"
                  >
                  </v-text-field>
                </v-col>
                <v-col
                  cols="12"
                  class="mt-n10"
                >
                  <v-autocomplete
                    :items="handi_data"
                    v-model="handi_type"
                    dense
                    label="ประเภทความพิการ"
                    item-text="TEXT"
                    item-value="VALUE"
                    solo
                  ></v-autocomplete>
                </v-col>
                <v-col
                  cols="12"
                  class="mt-n10"
                >
                  <v-autocomplete
                    v-model="organization"
                    :items="organization_list"
                    :loading="loading"
                    item-text="NAME"
                    item-value="NAME"
                    placeholder="หน่วยงาน"
                    solo
                  ></v-autocomplete>
                </v-col>
                <v-col cols="12">
                  <v-btn
                    style="width: 100%"
                    dark
                    color="#0089D6"
                    @click="search()"
                  >
                    <v-icon left>mdi-magnify</v-icon>ค้นหา
                  </v-btn>
                </v-col>
                <v-col cols="12">
                  <v-btn
                    style="width: 100%"
                    color="warning"
                    @click="clear()"
                  >
                    <v-icon left>mdi-close</v-icon>ล้างการค้นหา
                  </v-btn>
                </v-col>
                <v-col cols="12">
                  <v-btn
                    style="width: 100%"
                    color="#fff"
                    @click="export_xls()"
                  >
                    <v-icon left>mdi-printer</v-icon>ส่งออก excel
                  </v-btn>
                </v-col>
              </v-row>
            </v-card-title>
          </v-card>
        </v-col>
        <v-col
          cols="12"
          sm="12"
          lg="10"
        >
          <v-data-table
            dense
            :headers="headers"
            :items="tbl_data"
            class="elevation-1"
            hide-default-header
            :loading="tbl_load"
            :items-per-page="15"
            loading-text="กำลังเรียกข้อมูล..."
          >
            <template v-slot:header="{ props: { headers } }">
              <thead>
                <tr>
                  <th
                    class="n-ellipsis"
                    rowspan="3"
                  >แก้ไขข้อมูล</th>
                  <th
                    class="n-ellipsis"
                    rowspan="3"
                  >
                    {{ headers[0].text }}
                  </th>
                  <th
                    class="sticky-col first-col"
                    rowspan="3"
                  >
                    {{ headers[1].text }}
                  </th>
                  <th
                    class="n-ellipsis"
                    rowspan="3"
                  >
                    {{ headers[2].text }}
                  </th>
                  <th
                    class="n-ellipsis"
                    rowspan="3"
                  >
                    {{ headers[3].text }}
                  </th>
                  <th
                    class="n-ellipsis"
                    rowspan="3"
                  >
                    {{ headers[4].text }}
                  </th>
                  <th
                    class="n-ellipsis"
                    rowspan="3"
                  >
                    {{ headers[5].text }}
                  </th>
                </tr>
                <tr>
                  <th
                    class="n-ellipsis"
                    colspan="9"
                  >
                    {{ headers[6].text }}
                  </th>

                  <th
                    class="n-ellipsis"
                    colspan="3"
                  >
                    {{ headers[7].text }}
                  </th>
                  <th
                    class="n-ellipsis"
                    rowspan="3"
                  >
                    {{ headers[8].text }}
                  </th>
                </tr>
                <tr>
                  <th class="sub-th">น้ำหนัก</th>
                  <th class="sub-th">ส่วนสูง</th>
                  <th class="sub-th">รอบเอว</th>
                  <th class="sub-th">ความเครียด</th>
                  <th class="sub-th">ความมั่นใจ</th>
                  <th class="sub-th">ออกกำลังกาย (วัน)</th>
                  <th class="sub-th">กินผัก (วัน)</th>
                  <th class="sub-th">กินหวาน (วัน)</th>
                  <th class="sub-th">ดื่มน้ำ (วัน)</th>
                  <th class="sub-th">น้ำหนัก</th>
                  <th class="sub-th">ส่วนสูง</th>
                  <th class="sub-th">รอบเอว</th>
                </tr>
              </thead>
            </template>
            <template v-slot:item="{ item, index }">
              <tr>
                <td class="n-ellipsis">
                  <v-icon @click="edit_data(item)">mdi-file-document-edit-outline</v-icon>
                </td>
                <td class="n-ellipsis">{{ index + 1 }}</td>
                <td
                  class="sticky-col first-col th-ellipsis"
                  style="text-align: left !important"
                >
                  {{ item.FULLNAME }}
                </td>
                <td class="th-ellipsis">{{ item.CID }}</td>
                <td class="th-ellipsis">{{ item.HANDI_TYPE }}</td>
                <td class="th-ellipsis">{{ item.ORGANIZATION }}</td>
                <td class="th-ellipsis">{{ item.BIRTHDATE | filterDate }}</td>
                <td class="n-ellipsis">{{ item.START_WEIGHT }}</td>
                <td class="n-ellipsis">{{ item.START_HEIGHT }}</td>
                <td class="n-ellipsis">{{ item.START_WAIST }}</td>
                <td class="n-ellipsis">{{ item.STRESS_LEVEL }}</td>
                <td class="n-ellipsis">{{ item.CONFIDENCE_LEVEL }}</td>
                <td class="n-ellipsis">{{ item.ACTIVITY1 }}</td>
                <td class="n-ellipsis">{{ item.ACTIVITY2 }}</td>
                <td class="n-ellipsis">{{ item.ACTIVITY3 }}</td>
                <td class="n-ellipsis">{{ item.ACTIVITY4 }}</td>
                <td class="n-ellipsis">{{ item.END_WEIGHT }}</td>
                <td class="n-ellipsis">{{ item.END_HEIGHT }}</td>
                <td class="n-ellipsis">{{ item.END_WAIST }}</td>
                <td class="th-ellipsis">{{ item.GOAL }}</td>
              </tr>
            </template>
          </v-data-table>
        </v-col>
      </v-row>
      <v-row>
        <v-dialog
          v-model="e_dialog"
          max-width="800"
          :retain-focus="false"
        >
          <v-card>
            <v-card-title> แก้ไขข้อมูลผู้ลงทะเบียน </v-card-title>

            <v-card-text>
              <v-divider class="mb-3"></v-divider>
              <v-row justify="center">
                <v-col
                  cols="12"
                  lg="12"
                >
                  <v-row justify="center">
                    <v-col
                      cols="12"
                      lg="6"
                      class="mb-n5"
                    >
                      <div>
                        ระเภทผู้เข้าร่วมโครงการ
                        <v-autocomplete
                          v-model="p_type"
                          :items="[
                            'คนพิการ ในโครงการจ้างงานฯ',
                            'นจพ. หรือหน่วยงานในโครงการจ้างงานฯ',
                            'บุคคลทั่วไป ที่สนใจเข้าร่วมโครงการ',
                          ]"
                          solo
                          dense
                          class="mb-n5"
                        ></v-autocomplete>
                      </div>
                    </v-col>
                    <v-col
                      cols="12"
                      lg="6"
                      class="mb-n5"
                    >
                      <div>
                        โครงการที่ร่วม
                        <v-autocomplete
                          v-model="from_project"
                          :items="project_list"
                          item-text="NAME"
                          return-object
                          solo
                          dense
                          class="mb-n5"
                        ></v-autocomplete>
                      </div>
                    </v-col>
                  </v-row>
                  <v-row justify="center">
                    <v-col
                      cols="12"
                      lg="6"
                      class="mb-n5"
                    >
                      <div>
                        เลขบัตรประชาชน
                        <v-text-field
                          class="mt-0 pt-0"
                          type="text"
                          v-model="cid"
                          counter
                          solo
                          disabled
                          dense
                        ></v-text-field>
                      </div>
                    </v-col>
                    <v-col
                      cols="12"
                      lg="6"
                      class="mb-n5"
                    >
                      <div>
                        ชื่อ - นามสกุล
                        <v-text-field
                          class="mt-0 pt-0"
                          type="text"
                          v-model="e_fullname"
                        ></v-text-field>
                      </div>
                    </v-col>
                  </v-row>
                  <v-row justify="center">
                    <v-col
                      cols="12"
                      lg="6"
                      class="mb-n5"
                    >
                      <div>
                        หน่วยงาน
                        <v-autocomplete
                          v-model="comp_name"
                          :items="organization_list"
                          :loading="loading"
                          item-text="NAME"
                          item-value="NAME"
                          placeholder="พิมพ์เพื่อค้นหาหน่วยงาน"
                          solo
                          class="mb-n5"
                        ></v-autocomplete>
                      </div>
                    </v-col>
                    <v-col
                      cols="12"
                      lg="6"
                      class="mb-n5"
                    >
                      <div>
                        จังหวัด
                        <v-autocomplete
                          v-model="province"
                          :items="province_list"
                          placeholder="พิมพ์เพื่อค้นหาจังหวัด"
                          solo
                          class="mb-n5"
                        ></v-autocomplete>
                      </div>
                    </v-col>
                  </v-row>
                  <v-row justify="center">
                    <v-col
                      cols="12"
                      lg="6"
                      class="mb-n5"
                    >
                      <div>
                        ประเภทความพิการ
                        <v-select
                          class="mb-n5"
                          :items="list_handi_type"
                          v-model="se_handi_type"
                          label="เลือก"
                          solo
                        ></v-select>
                      </div>
                    </v-col>
                    <v-col
                      cols="12"
                      lg="6"
                      class="mb-n5"
                    >
                      <div>
                        วัน - เดือน - ปีเกิด
                        <v-menu
                          ref="menu"
                          v-model="menu"
                          :close-on-content-click="false"
                          transition="scale-transition"
                          offset-y
                        >
                          <template v-slot:activator="{ on, attrs }">
                            <v-text-field
                              class="mt-n3"
                              v-model="dateFormatted"
                              readonly
                              v-bind="attrs"
                              v-on="on"
                            ></v-text-field>
                          </template>
                          <v-date-picker
                            ref="picker"
                            locale="th"
                            v-model="date"
                          >
                            <v-spacer></v-spacer>
                            <v-btn
                              text
                              color="primary"
                              @click="menu = false"
                            >
                              ยกเลิก
                            </v-btn>
                            <v-btn
                              text
                              color="primary"
                              @click="$refs.menu.save(date)"
                            >
                              ตกลง
                            </v-btn>
                          </v-date-picker>
                        </v-menu>
                      </div>
                    </v-col>
                  </v-row>
                  <v-row justify="center">
                    <v-col
                      cols="12"
                      lg="4"
                      class="mb-n5"
                    >
                      <div>
                        ส่วนสูง (ซม.)
                        <v-text-field
                          class="mt-0 pt-0"
                          outlined
                          v-model="s_height"
                          dense
                          type="number"
                        ></v-text-field>
                      </div>
                    </v-col>
                    <v-col
                      cols="12"
                      lg="4"
                      class="mb-n5"
                    >
                      <div>
                        น้ำหนัก (กก.)
                        <v-text-field
                          class="mt-0 pt-0"
                          outlined
                          v-model="s_weight"
                          dense
                          type="number"
                        ></v-text-field>
                      </div>
                    </v-col>
                    <v-col
                      cols="12"
                      lg="4"
                      class="mb-n5"
                    >
                      <div>
                        รอบเอว (ซม.)
                        <v-text-field
                          class="mt-0 pt-0"
                          outlined
                          v-model="s_waist"
                          dense
                          type="number"
                        ></v-text-field>
                      </div>
                    </v-col>
                  </v-row>
                </v-col>
              </v-row>
              <v-row justify="center">
                <v-col
                  cols="12"
                  lg="6"
                >
                  <v-btn
                    color="warning"
                    width="100%"
                    @click="cancel()"
                  >
                    ยกเลิก
                  </v-btn>
                </v-col>
                <v-col
                  cols="12"
                  lg="6"
                >
                  <v-btn
                    color="success"
                    width="100%"
                    @click="save_edit()"
                  >
                    แก้ไข
                  </v-btn>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </v-dialog>
      </v-row>
    </div>
  </div>
</template>

<script>
import XLSX from 'xlsx';
import moment from 'moment';
export default {
  name: "RegisterSummary",
  components: {

  },
  data() {
    return {
      menu: false,
      province_list: ["กรุงเทพมหานคร"
        , "กระบี่"
        , "กาญจนบุรี"
        , "กาฬสินธุ์"
        , "กำแพงเพชร"
        , "ขอนแก่น"
        , "จันทบุรี"
        , "ฉะเชิงเทรา"
        , "ชัยนาท"
        , "ชัยภูมิ"
        , "ชุมพร"
        , "ชลบุรี"
        , "เชียงใหม่"
        , "เชียงราย"
        , "ตรัง"
        , "ตราด"
        , "ตาก"
        , "นครนายก"
        , "นครปฐม"
        , "นครพนม"
        , "นครราชสีมา"
        , "นครศรีธรรมราช"
        , "นครสวรรค์"
        , "นราธิวาส"
        , "น่าน"
        , "นนทบุรี"
        , "บึงกาฬ"
        , "บุรีรัมย์"
        , "ประจวบคีรีขันธ์"
        , "ปทุมธานี"
        , "ปราจีนบุรี"
        , "ปัตตานี"
        , "พะเยา"
        , "พระนครศรีอยุธยา"
        , "พังงา"
        , "พิจิตร"
        , "พิษณุโลก"
        , "เพชรบุรี"
        , "เพชรบูรณ์"
        , "แพร่"
        , "พัทลุง"
        , "ภูเก็ต"
        , "มหาสารคาม"
        , "มุกดาหาร"
        , "แม่ฮ่องสอน"
        , "ยโสธร"
        , "ยะลา"
        , "ร้อยเอ็ด"
        , "ระนอง"
        , "ระยอง"
        , "ราชบุรี"
        , "ลพบุรี"
        , "ลำปาง"
        , "ลำพูน"
        , "เลย"
        , "ศรีสะเกษ"
        , "สกลนคร"
        , "สงขลา"
        , "สมุทรสาคร"
        , "สมุทรปราการ"
        , "สมุทรสงคราม"
        , "สระแก้ว"
        , "สระบุรี"
        , "สิงห์บุรี"
        , "สุโขทัย"
        , "สุพรรณบุรี"
        , "สุราษฎร์ธานี"
        , "สุรินทร์"
        , "สตูล"
        , "หนองคาย"
        , "หนองบัวลำภู"
        , "อำนาจเจริญ"
        , "อุดรธานี"
        , "อุตรดิตถ์"
        , "อุทัยธานี"
        , "อุบลราชธานี"
        , "อ่างทอง"],
      p_type: null,
      project_list: [
        { NAME: "โครงการ 70 วันมหัศจรรย์ของฉัน ชีซั่น 9 (1 ก.ย. - 9 พ.ย. 66)", SS: 9, disabled: false },
        { NAME: "โครงการ 70 วันมหัศจรรย์ของฉัน ชีซั่น 8 (1 มิ.ย. - 10 ส.ค. 66)", SS: 8, disabled: true },
        { NAME: "โครงการ 70 วันมหัศจรรย์ของฉัน ชีซั่น 7 (1 มี.ค. - 10 พ.ค. 66)", SS: 7, disabled: true },
        { NAME: "โครงการ 70 วันมหัศจรรย์ของฉัน ชีซั่น 6 (4 ก.ค. - 11 ก.ย. 65)", SS: 6, disabled: true },
        { NAME: "โครงการ 70 วันมหัศจรรย์ของฉัน ชีซั่น 5 (25 เม.ย - 3 ก.ค. 65)", SS: 5, disabled: true },
        { NAME: "โครงการ 70 วันมหัศจรรย์ของฉัน ชีซั่น 4 (14 ก.พ. - 24 เม.ย 65)", SS: 4, disabled: true },
        { NAME: "โครงการ เกษียณสู้ต่อ", SS: 7, disabled: true },
        { NAME: "โครงการ พก.สนับสนุนคนพิการ นำร่องภารกิจสุขภาพดี", SS: 7, disabled: true },
        { NAME: "โครงการ Inclusive Workplace (IW)", SS: 7, disabled: true },
        { NAME: "โครงการ : 70 วันเราทำได้ (เฉพาะเจ้าหน้าที่มูลนิธินวัตกรรมทางสังคม)", SS: 7, disabled: true, },
        { NAME: "รอบพิเศษ สำหรับคนไม่ผ่านปี 65", SS: -6, disabled: true, },
      ],
      from_project: null,
      cid: null,
      fullname: null,
      e_fullname: null,
      organization_list: [],
      comp_name: [],
      province: null,
      e_dialog: false,
      loading: true,
      ss_data: [],
      tbl_load: true,
      comp_name: null,
      organization: null,
      range: [0, 280],
      se_handi_type: null,
      list_handi_type: [
        "ทางการเคลื่อนไหวหรือทางร่างกาย",
        "ทางการได้ยินหรือสื่อความหมาย",
        "ทางการเรียนรู้",
        "ทางการเห็น",
        "ทางจิตใจหรือพฤติกรรม",
        "ทางสติปัญญา",
        "ทางออทิสติก",
        "ไม่พิการ",
      ],
      ss: null,
      p_data: ["คนพิการ", "บุคคลทั่วไป", "นจพ."],
      fullname: null,
      handi_type: null,
      dateFormatted: null,
      s_waist: null,
      s_height: null,
      s_weight: null,
      date: null,
      handi_data: ["ทางการเคลื่อนไหวหรือทางร่างกาย", "ทางการได้ยินหรือสื่อความหมาย", "ทางการเรียนรู้", "ทางการเห็น", "ทางจิตใจหรือพฤติกรรม", "ทางสติปัญญา", "ทางออทิสติก", "ไม่พิการ"],
      provice: null,
      province_data: [],
      headers: [
        {
          text: "ลำดับ",
          align: "start",
          sortable: false,
          value: "id",
        },
        { text: "ชื่อ - นามสกุล", value: "FULLNAME", width: "260px" },
        { text: "เลขบัตรประชาชน", value: "CID" },
        { text: "ความพิการ", value: "HANDI_TYPE" },
        { text: "หน่วยงาน", value: "ORGANIZATION" },
        { text: "ว/ด/ป เกิด", value: "BIRTHDATE" },
        { text: "ก่อนเริ่มกิจกรรม", value: "" },
        { text: "หลังทำกิจกรรม", value: "" },
        { text: "เป้าหมาย", value: "GOAL" },
      ],
      tbl_data: []
    }
  },
  created() {
    this.initialApi()
  },
  filters: {
    filterDate(data) {
      return moment(data).add("y", 543).format("DD/MM/YYYY");
    },
  },
  watch: {
    date(val) {

      this.dateFormatted = this.formatDate(this.date);
    },

  },
  computed: {
    getIndex() {
      return this.tbl_data.map((item, index) => ({
        ...item,
        id: index + 1,
      }));
    },

  },
  methods: {
    cancel() {
      this.e_dialog = false
    },
    edit_data(item) {
      this.e_dialog = true
      this.p_type = item.P_TYPE
      this.from_project = item.FROM_PROJECT
      this.cid = item.CID
      this.e_fullname = item.FULLNAME
      this.comp_name = item.ORGANIZATION
      this.province = item.PROVINCE
      this.se_handi_type = item.HANDI_TYPE == 'null' ? 'ไม่พิการ' : item.HANDI_TYPE
      this.date = moment(item.BIRTHDATE).format('YYYY-MM-DD')
      this.s_height = item.START_HEIGHT
      this.s_weight = item.START_WEIGHT
      this.s_waist = item.START_WAIST
      //console.log(item)
    },
    save_edit() {
      this.$token_api
        .post("/admin-edit-user", {
          SEASON_ID: this.ss,
          CID: this.cid,
          P_TYPE: this.p_type,
          FROM_PROJECT: this.from_project.NAME,
          FULLNAME: this.e_fullname,
          ORGANIZATION: this.comp_name,
          PROVINCE: this.province,
          HANDI_TYPE: this.se_handi_type,
          BIRTHDATE: this.date,
          START_HEIGHT: this.s_height,
          START_WEIGHT: this.s_weight,
          START_WAIST: this.s_waist
        })
        .then((res) => {
          this.$swal("แก้ไขข้อมูลสำเร็จ", "", "success");
          this.api_summary_register()
          this.e_dialog = false
        })
        .catch((e) => {
          console.log(e);
        });
    },
    formatDate(val) {
      if (!val) return null;
      let n_date = moment(val).format('YYYY-MM-DD')
      let [year, month, day] = n_date.split("-");
      year = parseInt(year) + 543;
      return `${day}/${month}/${year}`;
    },
    get_organization() {
      this.$guest_api
        .get("/get-organization")
        .then((res) => {
          let result = res.data.data;
          if (result.length > 0) {
            this.organization_list = result;
            this.loading = false;
          }
        })
        .catch((e) => {
          this.loading = false;
        });
    },
    clear() {
      this.fullname = null
      this.handi_type = null
      this.organization = null
      this.api_summary_register()
    },
    initialApi() {
      this.get_organization()
      this.$token_api
        .get("/get-season-data")
        .then((res) => {
          const result = res.data.data;
          if (result.length > 0) {
            this.ss_data = result
            // this.ss = result[result.length - 1].ID
            this.get_current_season();
          }
        })
        .catch((e) => {
          console.log(e);
        });

    },
    get_current_season() {
      this.$token_api
        .get("/list-season-week")
        .then((res) => {
          const result2 = res.data.data;
          this.ss = result2.Season || 4
          this.api_summary_register();


        })
        .catch((e) => {
          console.log(e);
        });
    },
    api_summary_register() {
      this.$token_api.post('/register-report', { SEASON: this.ss, FULLNAME: this.fullname, HANDI_TYPE: this.handi_type, ORGANIZATION: this.organization }).then((res) => {
        const result = res.data.data;
        if (result.length > 0) {
          this.tbl_data = result
          this.tbl_load = false
        } else {
          this.tbl_load = false
          this.tbl_data = []
        }
      }).catch((e) => {
        this.tbl_load = false
        console.log(e)
      });
    },
    search() {
      this.api_summary_register()
    },
    th_formatDate(data) {
      return moment(data).add("y", 543).format("DD/MM/YYYY");
    },
    export_xls() {
      // this.LOADER(true)
      let data = this.tbl_data
      let xls_json = []
      if (data.length > 0) {
        data.forEach((element, i) => {
          xls_json.push({
            'ลำดับ': i + 1,
            'ชื่อ - นามสกุล': element.FULLNAME,
            'เลขบัตรประชาชน': element.CID,
            'ความพิการ': element.HANDI_TYPE,
            'หน่วยงาน': element.ORGANIZATION,
            'วดป เกิด': this.th_formatDate(element.BIRTHDATE),
            'น้ำหนัก(ก่อนเริม)': element.START_WEIGHT,
            'ส่วนสูง(ก่อนเริม)': element.START_HEIGHT,
            'รอบเอว(ก่อนเริม)': element.START_WAIST,
            'ความเครียด(ก่อนเริม)': element.STRESS_LEVEL,
            'ความมั่นใจ(ก่อนเริม)': element.CONFIDENCE_LEVEL,
            'ออกกำลังกาย(ก่อนเริม)': element.ACTIVITY1,
            'กินผัก(ก่อนเริม)': element.ACTIVITY2,
            'กินหวาน(ก่อนเริม)': element.ACTIVITY3,
            'ดื่มน้ำ(ก่อนเริม)': element.ACTIVITY4,
            'น้ำหนัก(หลังทำ)': element.END_WEIGHT,
            'ส่วนสูง(หลังทำ)': element.END_HEIGHT,
            'รอบเอว(หลังทำ)': element.END_WAIST,
            'เป้าหมาย': element.GOAL,
          });
        });
        const dataWS = XLSX.utils.json_to_sheet(xls_json);
        const wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, dataWS);
        XLSX.writeFile(wb, `รายงานจำนวนการลงทะเบียนทั้งหมด.xlsx`);
        // this.LOADER(false)
      } else {
        // this.LOADER(false)
        this.$swal({
          title: "ไม่พบข้อมูล",
          icon: "warning",
          text: `กรุณาค้นหาข้อมูลใหม่อีกครั้ง`,
          timer: 2000
        })
      }
    },
  },
};
</script>
